import i18n from "i18next";
import { initReactI18next } from "react-i18next";
// import LanguageDetector from "i18next-browser-languagedetector";
import { en } from "./locales/en";
import { ptBR } from "./locales/pt-BR";
import { esAR } from "./locales/es-AR";
export const resources = {
  "pt-BR": ptBR,
  en,
  "es-AR": esAR,
};

i18n
  // .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "pt-BR",
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
